export default "__VITE_ASSET__6YKAYn$O__"